var allhotel = [
  {
    id: '1',
    src: 'https://i.ibb.co/Sx4DW4g/Rectangle26.png',
    title: 'Light bright airy stylish apt & safe peaceful stay',
    size: '4 guests 2 bedrooms 2 beds 2 baths',
    facility: 'Wif Air conditioning kitchen',
    flexibility: 'Cancellation flexibility available',
    ratings: 4.9,
    price: 34,
    total: 167,
  },
  {
    id: '2',
    src: 'https://i.ibb.co/7znNQsY/7.jpg',
    title: 'Apartment in lost Panorama',
    size: '4 guests 2 bedrooms 2 beds 2 baths',
    facility: 'Wif Air conditioning kitchen',
    flexibility: 'Cancellation flexibility available',
    ratings: 4.8,
    price: 52,
    total: 158,
  },
  {
    id: '3',
    src: 'https://i.ibb.co/2PZkQYJ/6.jpg',
    title: 'AR Lounge & Pool (r&r + b&b)',
    size: '4 guests 2 bedrooms 2 beds 2 baths',
    facility: 'Wif Air conditioning kitchen',
    flexibility: 'Cancellation flexibility available',
    ratings: 4.9,
    price: 44,
    total: 160,
  },
  {
    id: '4',
    src: 'https://i.ibb.co/tHZ11fQ/5.jpg',
    title: 'Royal Tulip Sea Pearl Beach Resort & Spa',
    size: '4 guests 2 bedrooms 2 beds 2 baths',
    facility: 'Breakfast included',
    flexibility: 'Cancellation flexibility available',
    ratings: 4.9,
    price: 48,
    total: 157,
  },
  {
    id: '5',
    src: 'https://i.ibb.co/pL7LSxn/4.jpg',
    title: 'Long Beach Hotel',
    size: '4 guests 2 bedrooms 2 beds 2 baths',
    facility: 'Breakfast included',
    flexibility: 'Cancellation flexibility available',
    ratings: 4.7,
    price: 45,
    total: 150,
  },
  {
    id: '6',
    src: 'https://i.ibb.co/LvVFvSG/3.jpg',
    title: 'Hotel Prime Park',
    size: '4 guests 2 bedrooms 2 beds 2 baths',
    facility: 'Breakfast included',
    flexibility: 'Cancellation flexibility available',
    ratings: 4.9,
    price: 55,
    total: 165,
  },
  {
    id: '7',
    src: 'https://i.ibb.co/HxKgLdK/2.jpg',
    title: 'Hotel Sea Crown',
    size: '4 guests 2 bedrooms 2 beds 2 baths',
    facility: 'Wif Air conditioning kitchen',
    flexibility: 'Cancellation flexibility available',
    ratings: 4.8,
    price: 52,
    total: 162,
  },
  {
    id: '8',
    src: 'https://i.ibb.co/NmG2NM8/Rectangle27.png',
    title: 'Neeshorgo Hotel & Resort',
    size: '4 guests 2 bedrooms 2 beds 2 baths',
    facility: 'Wif Air conditioning kitchen',
    flexibility: 'Cancellation flexibility available',
    ratings: 4.7,
    price: 48,
    total: 155,
  },
  {
    id: '9',
    src: 'https://i.ibb.co/Sx4DW4g/Rectangle26.png',
    title: 'Windy Terrace Boutique Hotel',
    size: '4 guests 2 bedrooms 2 beds 2 baths',
    facility: 'Wif Air conditioning kitchen',
    flexibility: 'Cancellation flexibility available',
    ratings: 4.9,
    price: 55,
    total: 167,
  },
];

export default allhotel;
